var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"5":1,"62":1,"304":1,"350":1,"360":1,"374":1,"410":1,"542":1,"607":1,"642":1,"651":1,"684":1,"691":1,"703":1,"737":1,"750":1,"819":1,"844":1,"847":1,"1000":1,"1096":1,"1185":1,"1274":1,"1287":1,"1484":1,"1518":1,"1613":1,"1630":1,"1779":1,"1787":1,"1814":1,"1969":1,"2094":1,"2106":1,"2165":1,"2206":1,"2346":1,"2376":1,"2395":1,"2405":1,"2478":1,"2579":1,"2580":1,"2660":1,"2811":1,"2842":1,"2860":1,"2870":1,"2876":1,"2982":1,"3010":1,"3074":1,"3229":1,"3282":1,"3295":1,"3447":1,"3475":1,"3538":1,"3545":1,"3582":1,"3622":1,"3649":1,"3658":1,"3686":1,"3705":1,"3742":1,"3753":1,"3834":1,"3978":1,"4007":1,"4068":1,"4099":1,"4149":1,"4170":1,"4235":1,"4496":1,"4521":1,"4578":1,"4632":1,"4726":1,"4741":1,"4802":1,"4870":1,"5001":1,"5071":1,"5098":1,"5136":1,"5148":1,"5151":1,"5174":1,"5201":1,"5258":1,"5339":1,"5495":1,"5530":1,"5532":1,"5558":1,"5704":1,"5792":1,"5858":1,"5926":1,"6057":1,"6135":1,"6184":1,"6207":1,"6282":1,"6293":1,"6294":1,"6351":1,"6437":1,"6522":1,"6698":1,"6747":1,"6875":1,"6880":1,"7029":1,"7274":1,"7329":1,"7421":1,"7422":1,"7490":1,"7666":1,"7726":1,"7775":1,"7913":1,"8000":1,"8118":1,"8220":1,"8378":1,"8491":1,"8672":1,"8680":1,"8728":1,"8760":1,"8818":1,"8837":1,"8859":1,"8946":1,"9004":1,"9068":1,"9122":1,"9154":1,"9184":1,"9287":1,"9303":1,"9307":1,"9453":1,"9488":1,"9494":1,"9536":1,"9570":1,"9647":1,"9735":1,"9756":1,"9869":1,"9885":1,"9889":1,"9903":1,"9934":1,"9944":1,"9955":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr